export class CandidateExperiencesHelpers {
  static getExperiencesGroupedByQualification({ experiences = [] }) {
    const ExperiencesGroups = [];
    experiences.forEach((experience) => {
      // we group by qualification label
      const qualificationLabel = experience.getQualification().getLabel();
      let group = ExperiencesGroups.find((g) => g.name === qualificationLabel);
      if (!group) {
        group = { name: qualificationLabel, experiences: [] };
        ExperiencesGroups.push(group);
      }
      group.experiences.push(experience);
    });

    return ExperiencesGroups;
  }

  static sortExperiencesByStartDate(experiences = []) {
    return experiences.sort((a, b) => {
      return b.getStartTimestamp() - a.getStartTimestamp();
    });
  }
}
